export const MEMBER_TABS = {
    profile: 'profile',
    status: 'status',
    conversation: 'conversation',
    routing: 'routing',
    workingHours: 'workingHours',
    checks: 'checks',
    location: 'tracks',
    jobs: 'jobs',
    timeline: 'timeline',
    settings: 'settings',
}

export const COMPANY_TABS = {
    company: 'company',
    general: 'general',
    settings: 'settings',
    permissions: 'permissions',
    jobSettings: 'dispatchSettings',
    coDispatch: 'codispatch',
    billing: 'billing',
}

export type CompanyTabKeys = 'company' | 'general' | 'settings' | 'permissions' | 'dispatchSettings' | 'codispatch' | 'billing';
